if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

  // Show all content

  $(".media-inquiry-btn").click(function () {
    $("#media-inquiry").fadeToggle();
  });

  $(".login-show").click(function () {
    $("#frmLogin").slideToggle();
  });

  $(".press-grid__entry .open-content").click(function (event) {
    event.preventDefault();
    if (
      $(this)
        .closest(".press-grid__entry")
        .find(".press-grid__entry__full")
        .is(":hidden")
    ) {
      $(this)
        .closest(".press-grid__entry")
        .find(".press-grid__entry__full")
        .slideDown(600);
      $(this).text("Learn Less");
    } else {
      $(this)
        .closest(".press-grid__entry")
        .find(".press-grid__entry__full")
        .slideUp(600);
      $(this).text("Learn More");
    }
  });

  $(".blog-grid__entry .open-content").click(function (event) {
    event.preventDefault();
    if (
      $(this)
        .closest(".blog-grid__entry")
        .find(".blog-grid__entry__full")
        .is(":hidden")
    ) {
      $(this)
        .closest(".blog-grid__entry")
        .find(".blog-grid__entry__full")
        .slideDown(600);
      $(this).text("Learn Less");
    } else {
      $(this)
        .closest(".blog-grid__entry")
        .find(".blog-grid__entry__full")
        .slideUp(600);
      $(this).text("Learn More");
    }
  });

  $(".headline-box .open-content").click(function (event) {
    event.preventDefault();
    if (
      $(this).closest(".headline-box").find(".headline-box__full").is(":hidden")
    ) {
      $(this)
        .closest(".headline-box")
        .find(".headline-box__full")
        .slideDown(600);
      $(this).text("Read Less").addClass("less");
    } else {
      $(this).closest(".headline-box").find(".headline-box__full").slideUp(600);
      $(this).text("Read More").removeClass("less");
    }
  });

  $(".special-text-inner .open-content").click(function (event) {
    event.preventDefault();
    if (
      $(this)
        .closest(".special-text-inner")
        .find(".special-text-inner__full")
        .is(":hidden")
    ) {
      $(this)
        .closest(".special-text-inner")
        .find(".special-text-inner__full")
        .slideDown(600);
      $(this).text("Close").addClass("less");
    } else {
      $(this)
        .closest(".special-text-inner")
        .find(".special-text-inner__full")
        .slideUp(600);
      $(this).text("Terms & Conditions").removeClass("less");
    }
  });

  $(".list-amenities .open-content").click(function (event) {
    event.preventDefault();
    if (
      $(this).closest(".list-amenities").find(".full-amenities").is(":hidden")
    ) {
      $(this).closest(".list-amenities").find(".full-amenities").slideDown(600);
      $(this).text("Close").addClass("less");
    } else {
      $(this).closest(".list-amenities").find(".full-amenities").slideUp(600);
      $(this).text("Additional room features").removeClass("less");
    }
  });

  $(".room-text-inner .open-content").click(function (event) {
    event.preventDefault();
    if (
      $(this).closest(".room-text-inner").find(".full-amenities").is(":hidden")
    ) {
      $(this)
        .closest(".room-text-inner")
        .find(".full-amenities")
        .slideDown(600);
      $(this).text("Close").addClass("less");
    } else {
      $(this).closest(".room-text-inner").find(".full-amenities").slideUp(600);
      $(this).text("Read more").removeClass("less");
    }
  });

  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );

  $(".sym-slides").slick();

  $(".gallery-quad__slider").slick({
    accessibility: true,
    dots: false,
    arrows: true,
    slidesToShow: 3,
    speed: 600,
    fade: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  // $(".slider-three-column__slider").slick({
  //   fade: false,
  //   dots: true,
  //   arrows: false,
  //   slidesToShow: 3,
  //   accessibility: true,
  //   autoplaySpeed: 3000,
  //   responsive: [
  //     {
  //       breakpoint: 900,
  //       settings: {
  //         slidesToShow: 2,
  //       },
  //     },
  //     {
  //       breakpoint: 641,
  //       settings: {
  //         dots: true,
  //         arrows: false,
  //         slidesToShow: 1,
  //       },
  //     },
  //   ],
  // });

  //accordion module

  const tabAccordionElement =
    [...document.getElementsByClassName("js-title-toggle")] || [];
  const contentAccordionElement =
    [...document.getElementsByClassName("js-info-toggle")] || [];

  tabAccordionElement.forEach(function (elementTab) {
    elementTab.addEventListener("click", function () {
      const clickedElement = this;
      clickedElement.classList.toggle("change-icon");
      tabAccordionElement.forEach(function (elementClass) {
        if (elementClass !== clickedElement)
          elementClass.classList.remove("change-icon");
      });
      contentAccordionElement.forEach(function (elementContent) {
        let dataElementTab = elementTab.dataset.expand;
        let dataElementContent = elementContent.dataset.expand;

        elementContent.classList.add("info-toggle");

        if (elementTab.classList.contains("change-icon")) {
          if (dataElementTab === dataElementContent) {
            elementContent.classList.remove("info-toggle");
          }
        } else {
          if (dataElementTab === dataElementContent) {
            elementContent.classList.add("info-toggle");
          }
        }
      });
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const h3Elements = document.querySelectorAll('.ada-map__list h3');

    h3Elements.forEach(h3 => {
        if (h3.innerHTML.length > 0) {
            const h2Element = document.createElement('h2');
            h2Element.innerHTML = h3.innerHTML;
            h3.parentNode.replaceChild(h2Element, h3);
        }
    });
});

  //ventlistener Inqury Type change.
  /*  const inquryType = document.getElementById('inqury_type');
     inquryType.addEventListener('change',()=>{
         console.log(this.value);
     }) */

  /*  let select = document.getElementById('inqury_type');
    select.addEventListener('change', function () {
        console.log(this.value);        
    }); */
})();
